import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import { SuperModelForm, SuperModelListResponse } from "../types";
import {
  selectSuperModelForm,
  selectSuperModelPage,
  selectSuperModelPerPage,
} from "./selector";
import { superModelActions } from "./slice";

let isFetchingList = false;

export function* handleGetSuperModelsList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectSuperModelPage);
    const perPage: number = yield select(selectSuperModelPerPage);

    const response: SuperModelListResponse = yield call(
      request,
      `${API_URL}/super-model/list?page=${page}&perPage=${perPage}`,
      { method: "GET" }
    );

    const data = response?.data || [];
    const meta = getPaginationMeta(page, perPage, data, response?.meta);
    const payload = { data, meta };

    if (page === 1) {
      yield put(superModelActions.getSuperModelsListSuccess(payload));
    } else {
      yield put(superModelActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectSuperModelPage);

    if (page === 1) {
      yield put(superModelActions.getSuperModelsListError(message));
    } else {
      yield put(superModelActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddSuperModel() {
  const form: SuperModelForm = yield select(selectSuperModelForm);

  try {
    yield call(request, `${API_URL}/super-model`, {
      method: "POST",
      body: JSON.stringify({
        superModelName: form.name.trim(),
        manufacturerId: Number(form.manufacturer),
        priority: Number(form.priority),
      }),
    });

    yield put(superModelActions.addSuperModelSuccess());
    yield put(superModelActions.getSuperModelsList());
  } catch (error) {
    yield put(
      superModelActions.addSuperModelError((error as Error).message)
    );
  }
}

export function* superModelSaga() {
  yield takeLeading(
    superModelActions.getSuperModelsList.type,
    handleGetSuperModelsList
  );
  yield takeLeading(
    superModelActions.getNextPageItems.type,
    handleGetSuperModelsList
  );
  yield takeLatest(
    superModelActions.addSuperModel.type,
    handleAddSuperModel
  );
}

export default superModelSaga;
